import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Spinner } from "reactstrap";
import { ClientInput } from "../../types/clientInput.types";
import { getClientInputs } from "../../Api/ApiUrlConst";
import ClientInputThread from "./ClientInputThread";
import ClientInputForm from "./ClientInputForm";
import { useAuth } from "../../Context/AuthContext";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  entityType: "task" | "subtask" |"childSubTask";
  entityId: number;
  isClientInputEnabled: boolean;
   onToggle?: (enabled: boolean) => void;
  canCreate: boolean;
}

const ClientInputModal: React.FC<Props> = ({
  isOpen,
  toggle,
  entityType,
  entityId,
  isClientInputEnabled,
  onToggle,
  canCreate
}) => {
  const [inputs, setInputs] = useState<ClientInput[]>([]);
  const [loading, setLoading] = useState(false);
  const { role } = useAuth();

  const loadInputs = async () => {
    setLoading(true);
    try {
      const res = await getClientInputs(entityType, entityId);
      setInputs(res.data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) loadInputs();
  }, [isOpen, entityType, entityId]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Client Input</ModalHeader>

      <ModalBody>
        {loading && <Spinner />}

        {!loading &&
          inputs.map(input => (
            <ClientInputThread
              key={input.id}
              input={input}
              onReplySuccess={loadInputs}
            />
          ))}

        {canCreate && role !== "Client" && (
          <ClientInputForm
            entityType={entityType}
            entityId={entityId}
            onSuccess={loadInputs}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default ClientInputModal;
